class CartFreeShippingProgress extends HTMLElement {
  MIN_VALUE_FOR_FREE_SHIPPING = 9900;
  MIN_VALUE_TO_SHOW_CONTAINER = 3000;

  constructor() {
    super();
    document.addEventListener("ajaxProduct:added", (evt) => {
      let cartValue = this.getCartValue();
    });

    document.addEventListener("cart:updated", (evt) => {
      let { total_price } = evt.detail.cart;
      this.updateValues(total_price);
    });
  }

  calculateRemainValue = (value) => this.MIN_VALUE_FOR_FREE_SHIPPING - value;
  showContainer = () =>
    document
      .querySelector(".free-shipping__container")
      .classList.add("show-free-shipping-progress");
  hideContainer = () =>
    document
      .querySelector(".free-shipping__container")
      .classList.remove("show-free-shipping-progress");

  async getCartValue() {
    try {
      let res = await fetch("/cart.js");
      let json = await res.json();
      let { total_price } = await json;

      if (total_price) this.updateValues(total_price);
    } catch (error) {
      console.error("ERROR:::: ", error);
    }
  }

  updateValues(value) {
    let getRemainValue = this.calculateRemainValue(value);

    if (getRemainValue < 0 || getRemainValue > 3000) {
      this.hideContainer();
      return;
    }

    document.querySelector("#remain-value").innerHTML = `${formatMoney(
      getRemainValue
    )}`;
    this.showContainer();
  }
}
customElements.define("cart-free-shipping-progress", CartFreeShippingProgress);
